import { configureStore } from "@reduxjs/toolkit";
import lessonReducer from "../features/lessons/lessonSlice"
import formsReducer from "../features/forms/formsSlice"
import progressChartReducer from "../features/progressChart/progressChartSlice"
import authReducer from "../features/auth/authSlice";
import studentLessonReducer from "../features/studentLessons/studentLessonsSlice"
import adminReducer from "../features/admin/adminSlice"
import teacherReducer from "../features/teacher/teacherSlice"
import vocabReducer from "../features/vocab/vocabSlice"
import guestReducer from "../features/guest/guestSlice"
import langReducer from "../features/language/languageSlice"

const store = configureStore({
    reducer: {
        lesson: lessonReducer,
        forms: formsReducer,
        progressChart: progressChartReducer,
        auth: authReducer,
        studentLessons: studentLessonReducer,
        admin: adminReducer,
        teacher: teacherReducer,
        vocab: vocabReducer,
        guest: guestReducer,
        lang: langReducer,
     }
})

export default store